/** Bannières `public/images/` — alignées sur AcademiaHomePage et AdminPageHero. */
export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const ACADEMIA_HERO_BANNERS = {
  campus1: 'hero-banner-1.jpg',
  campus2: 'hero-banner-2.jpg',
  campus3: 'hero-banner-3.jpg',
} as const;

export function academiaHeroImageUrl(filename: string): string {
  return `${PUBLIC_URL}/images/${filename}`;
}

export const HERO_CAROUSEL_URLS = [
  academiaHeroImageUrl(ACADEMIA_HERO_BANNERS.campus1),
  academiaHeroImageUrl(ACADEMIA_HERO_BANNERS.campus2),
  academiaHeroImageUrl(ACADEMIA_HERO_BANNERS.campus3),
];

/** Visuel principal par page filière publique (`/filieres/:slug`) et cartes carrousel accueil. */
export const FILIERE_TRACK_HERO_IMAGE: Record<string, string> = {
  'numeriques-technologiques': 'hero-banner-1.jpg',
  'administratives-gestion': 'hero-banner-2.jpg',
  'communication-marketing': 'hero-banner-3.jpg',
  'techniques-professionnelles': 'hero-banner-4.jpg',
  'entrepreneuriales-strategiques': 'hero-banner-5.jpg',
};

export function filiereTrackHeroFile(trackSlug: string): string {
  return FILIERE_TRACK_HERO_IMAGE[trackSlug] ?? ACADEMIA_HERO_BANNERS.campus2;
}

export function filiereTrackHeroUrl(trackSlug: string): string {
  return academiaHeroImageUrl(filiereTrackHeroFile(trackSlug));
}
